import { render, staticRenderFns } from "./EditContactPad.vue?vue&type=template&id=4feb82ff&scoped=true"
import script from "./EditContactPad.vue?vue&type=script&lang=js"
export * from "./EditContactPad.vue?vue&type=script&lang=js"
import style0 from "./EditContactPad.vue?vue&type=style&index=0&id=4feb82ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb82ff",
  null
  
)

export default component.exports